import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const DYNAMIC_STORAGE_KEY = 'dynamic';

// Експорт для сумісності з legacy кодом
export const dynamicLocalStoreKey = DYNAMIC_STORAGE_KEY;

interface DynamicState {
  company?: any;
  configuration?: any;
  [key: string]: any;
}

const initialState: DynamicState = {
  company: null,
  configuration: null,
};

export const dynamicSlice = createSlice({
  name: 'dynamic',
  initialState,
  reducers: {
    getDynamicVariableFromLocalStore: state => {
      const data = localStorage.getItem(DYNAMIC_STORAGE_KEY);
      if (data) {
        const parsed = JSON.parse(data);
        Object.keys(parsed).forEach(key => {
          state[key] = parsed[key];
        });
      }
    },
    setDynamicVariables: (
      state,
      action: PayloadAction<Record<string, any>>
    ) => {
      Object.keys(action.payload).forEach(key => {
        state[key] = action.payload[key];
      });
      localStorage.setItem(DYNAMIC_STORAGE_KEY, JSON.stringify(state));
    },
  },
});

export const { setDynamicVariables, getDynamicVariableFromLocalStore } =
  dynamicSlice.actions;

export const selectDynamic = (state: any) => state.dynamic;
export const selectDynamicCompany = (state: any) => state.dynamic.company;
export const selectDynamicConfiguration = (state: any) =>
  state.dynamic.configuration;

export default dynamicSlice.reducer;
